import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { AddEditWorkExperience } from './form';
import { RATING_ICON } from './data';
import { WorkExperienceContext } from './context';
import { sumBy, clamp } from 'lodash';
import { wowActions, wowAwardAction, enterDrawAction } from '../../_global/js/_api';
import { generateWowCertificate } from './generateWowCertificate';

export const WowChallenge = ({ matrixUserData }) => {
    const { state, dispatch } = useContext(WorkExperienceContext);
    const [showForm, setShowForm] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showAddSuccess, setShowAddSuccess] = useState(false);
    const [item, setItem] = useState();

    const onLoad = useRef();
    const wowData = state.length ? state[1] : [];

    const percentage = useMemo(() => calculateProgress(wowData), [state]);

    useEffect(() => {
        const timer = setTimeout(() => {
            wowActions({type: "get"}).then((data)=> {
                if(data) {
                    dispatch({
                        type: 'get',
                        data
                    });
                }            
            })
        }, 150);

        return () => clearTimeout(timer);
    }, [onLoad]);

    useEffect(() => {
        const dsUserData = state.length ? state[0] : [];
        const currentProgress = dsUserData.wowChallenge && dsUserData.wowChallenge.length > 0 ? dsUserData.wowChallenge[0] : 0;
        const awardId = dsUserData.wowChallenge && dsUserData.wowChallenge.length > 0 ? dsUserData.wowChallenge[1] : null;

        // console.log(state, currentProgress);

        const showFiftyHoursAward = (percentage >= 50 && currentProgress != "50" && currentProgress != "100") ? 50 : null;
        const showHundredHoursAward = (percentage >= 100 && currentProgress != "100") ? 100 : null;
        const showAwards = showFiftyHoursAward || showHundredHoursAward;
        // setShowOverlay(true);
        // setShowAddSuccess(true);

        if(showAwards) {
            wowAwardAction({id: awardId, wowState: showAwards}).then((response) => {
                // console.log(response);
                dispatch({
                    type: 'update-milestone',
                    info: response
                });
                const timer = setTimeout(() => {
                    setShowOverlay(true);
                    setShowAddSuccess(true);
                }, 600);
            
                return () => clearTimeout(timer);
            })
        }
    }, [state]);

    useEffect(() => {
        if(showOverlay && showForm){
            const editForm = document.querySelector('.add-edit__form');
            editForm.querySelectorAll('input')[0].focus();
        }
    }, [showOverlay]);

    const handleHideForm = () => {
        setShowForm(false);
        setShowOverlay(false);
        setShowAddSuccess(false);
        setItem();
    }

    const handleAddOrEditForm = (itemId) => {
        setShowOverlay(true);
        const index = typeof itemId === 'number' ? itemId : null;
        setItem({info: wowData[itemId], index});
        setShowForm(true);
    }

    const handleShowRemoveButton = () => {
        setShowRemoveButton(true);
    }

    const handleSubmitForm = (experience) => {
        setShowLoader(true);
        wowActions(experience).then((response) => {
            const itemObject = experience.type === 'remove' ? experience.data : response;
            dispatch({
                type: experience.type,
                item: itemObject
            });
            setShowLoader(false);
            setShowForm(false);
            setShowOverlay(false);
            setShowRemoveButton(false);
        });
    }

    const downloadWowCertRef = useRef(null);
    const hoursCompleted = wowData.length ? calculateProgress(wowData) : 0
    const milestone = (
          hoursCompleted >= 100 ? 100
        : hoursCompleted >= 50 ? 50 
        : 0
    )

    return (
        <div className="add-edit">
            {wowData.length ? (
                <LandPageProgressBar
                    matrixUserData={matrixUserData}
                />
            ) :
                null
            }
            <div>
                <h3>Build your knowledge of the World of Work (WOW) through the WOW Challenge!</h3>

                <p>Add the time you have spent exploring your career options through work experience, volunteering, paid employment, attending expos and events and other activities below. Once you reach 100 hours and have it validated by your teacher, you go into the draw to win a mentoring session with a professional in an industry of your choice!</p>
            </div>

            <div className="add-edit__cta action__button">
                <button 
                    className="button--normal"
                    onClick={handleAddOrEditForm}
                    type="button"
                >
                    <i className="fas fa-plus"></i>
                    Add WOW Challenge activity
                </button>
            </div>

            {wowData.length ? (
                <>
                    <PrintAllExperience experiences={wowData} editAction={handleAddOrEditForm} submitForm={handleSubmitForm} />

                    {wowData.length > 0 && <button className="wow-cert-dl__button" onClick={()=>{
                        generateWowCertificate(
                            matrixUserData, 
                            wowData,
                            milestone,
                            downloadWowCertRef,
                        )
                    }}>Download your work log</button>}

                    {wowData.length >= 3 ? 
                        <div className="add-edit__cta action__button">
                            <button 
                                className="button--normal"
                                onClick={handleAddOrEditForm}
                                type="button"
                            >
                                <i className="fas fa-plus"></i>
                                Add WOW Challenge activity
                            </button>
                        </div>
                        : null
                    }
                </>                
            ) :
                null
            }

            {
                showOverlay ? (
                    <div id="add-edit" className="add-edit__wrapper">
                        <div className="screen-overlay" onClick={handleHideForm} />
                        
                        <div className="add-edit__container">
                            <button
                                className="add-edit__close toggle__close"
                                type="button"
                                aria-controls="add-edit"
                                aria-expanded="true"
                                aria-label="Toggle add/edit work experience"
                                tabIndex="0"
                                onClick={handleHideForm}
                            >
                                <span className="toggle__close-text">
                                    Close
                                </span>
                                <i className="fas fa-times"></i>
                            </button>
                            
                            {showForm ? (
                                <AddEditWorkExperience item={item.info} itemIndex={item.index} closeForm={handleHideForm} submitForm={handleSubmitForm} showRemoveButton={handleShowRemoveButton} />
                            ) : null}

                            {showAddSuccess ? (
                                <SuccessMessage matrixUserData={matrixUserData} closeForm={handleHideForm} />
                            ) : null}
                            

                        </div>
                        
                        {showRemoveButton ? (
                            <>
                                <div className="screen-overlay" onClick={() => setShowRemoveButton(false)} />
                                <div className="remove-button__container">
                                    <div className="action__button">
                                        <p>Are you sure you want to remove?</p>
                                        <button 
                                            type="button" 
                                            className="button--submit" 
                                            onClick={() => setShowRemoveButton(false)}
                                            >
                                            Cancel
                                        </button>
                                        <button 
                                            type="submit" 
                                            className="button--submit add-edit__form-remove" 
                                            onClick={() => handleSubmitForm({id: item.info.id, data: item, type: 'remove'})}
                                            >
                                            Yes
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : null}
                        
                        {showLoader ? <div className="loading" /> : null}
                    </div>
                ) :
                null
            }
            
        </div>
    );
};

const PrintAllExperience = ({experiences, editAction}) => {
    const listAllExperience = experiences.map((experience, ei) => {
        const { expName, expType, hoursCompleted, startDate, endDate, rating, lessonsLearned } = experience;

        const printType = expType.map((category, ci) => {
            return (
                <span className="experience-list__item-cat" key={ci}>{category}</span>
            )
        });

        const handleEditItem = () => {
            editAction(ei)
        }

        return (
            <li className="experience-list__item" key={ei}>
                <div className="experience-list__item-header">
                    <h3 className="experience-list__item-name">{expName}</h3>
                    <div className="experience-list__item-details">
                        <p className="experience-list__item-type">
                            <span className="sr-only">Work experience type: </span>
                            {printType}
                        </p>
                        <p className="experience-list__item-date">
                            <span className="sr-only">Date: </span>
                            {format(parseISO(startDate), 'dd/MM/yyyy') + ' - ' + format(parseISO(endDate), 'dd/MM/yyyy')}
                        </p>
                    </div>
                </div>
                <p className="experience-list__item-time">
                    <span className="experience-list__item-hours">{Math.round((hoursCompleted / 60) * 10) / 10}</span>
                    <span> hours</span>
                </p>
                <h4 className="experience-list__item-lessons-heading">My reflections</h4>
                <div className="experience-list__item-lessons">
                    <span className="experience-list__item-rating"><i className={'far ' + RATING_ICON[rating.toLowerCase()]}></i></span>
                    {lessonsLearned}
                </div>
                <button 
                    className="experience-list__item-edit"
                    type="button" 
                    onClick={handleEditItem}
                >
                    <span className="sr-only">Edit {expName}</span>
                    <i className="far fa-edit"></i>
                </button> 
            </li>
        )
    });

    return (
        <div className="experience-list__container">
            <h2 className="sr-only">List of all experiences added</h2>
            <ul className="experience-list__list">
                {listAllExperience}
            </ul>
        </div>
    )
}

const SuccessMessage = ({closeForm, matrixUserData}) => {
    const { state } = useContext(WorkExperienceContext);
    const wowData = state[1];
    const totalHoursCompleted = useMemo(() => calculateProgress(wowData), [wowData]);

    const showFiftyHoursAward = (totalHoursCompleted >= 50 && totalHoursCompleted < 100);
    const showHundredHoursAward = (totalHoursCompleted >= 100);

    const handleEnterDrawClick = (button) => {
        const buttonEl = button.target;
        enterDrawAction().then(() => {
            buttonEl.disabled = 'disabled';
            buttonEl.innerText = 'Submission received';
        });
    }

    return (
        <div className="success-message__container">
            <h2 className="success-message__title">Congratulations on reaching <br />{totalHoursCompleted} hours of work exposure!</h2>

            {totalHoursCompleted >= 50 ? (
                <>
                    <div className="success-message__badge-wrapper">
                        {showFiftyHoursAward ? (
                            <div className="success-message__badge">
                                <i className="fas fa-award"></i>
                                <p className="success-message__badge-time"><span className="success-message__badge-hours">50</span> <br />hours</p>
                            </div>
                        ) : null}
                        

                        {totalHoursCompleted >= 100 && showHundredHoursAward ? (
                            <div className="success-message__badge">
                                <i className="fas fa-star"></i>
                                <p className="success-message__badge-time"><span className="success-message__badge-hours">100</span> <br />hours</p>
                            </div>
                        ) : null}
                    </div>
                    {totalHoursCompleted >= 100 && showHundredHoursAward ? (
                        <>
                        
                            <p className="wow-enter-draw__text">Congratulations on achieiving your 100 hours in the WOW challenge! You are now eligible to enter our competition to win a mentoring session with a professional from an industry of your choice!</p>

                            <button className="wow-enter-draw__button" onClick={handleEnterDrawClick}>Enter the draw</button>
                        </>
                        ) : null}
                    <DownloadWowCertificate
                        matrixUserData={matrixUserData} currentExp={wowData}
                    />
                    <h3 className="success-message__subtitle">Download your certificate, have it signed by your teacher and upload it to your CV builder!</h3>
                </>
            ) : null}
            
            <ProgressBar />

            <div className="form__submit">
                <button 
                    type="submit" 
                    className="button--submit add-edit__form-submit" 
                    onClick={closeForm}
                >
                    Close window
                </button>
            </div>
        </div>
    )
}

const calculateProgress = (state) => {
    return clamp((Math.round((sumBy(state, 'hoursCompleted') / 60) * 10) / 10), 0, 100);
}

const ProgressBar = () => {
    const { state } = useContext(WorkExperienceContext);
    const [percentage, setPercentage] = useState();
    const wowData = state[1];

    const totalHoursCompleted = useMemo(() => calculateProgress(wowData), [state]);

    const completedHalf = totalHoursCompleted >= 50 ? ' complete' : '';

    useEffect(()=> {
        const timer = setTimeout(() => {
            setPercentage(totalHoursCompleted);
          }, 600);
          return () => clearTimeout(timer);
    },[state]);

    return (
        <div className="progress-bar__container">
            <div className="progress-bar__current-container">
            {totalHoursCompleted !== 100 ? (
                <div 
                    className="progress-bar__current"
                    style={{left: percentage + '%'}} 
                >
                    <i className="fas fa-check"></i>
                    <span className="progress-bar__current-text">{totalHoursCompleted} hours completed!</span>
                </div>
            ) : null}
            </div>
            
            <div className="progress-bar__strip-container">
                <div className="progress-bar__strip-current" style={{left: percentage + '%'}}/>
                <div className="progress-bar__strip">
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                    <div className="progress-bar__block" />
                </div>
            </div>
            <div className="progress-bar__middle progress-bar__badge">
                <p className="progress-bar__label">
                    <span className="sr-only">{completedHalf ? "You've passed " : "You haven't reached "} </span>
                    50 hours
                </p>
                <i className={"fas fa-award" + completedHalf}></i>
            </div>
            <div className="progress-bar__end progress-bar__badge">
                <p className="progress-bar__label">
                    <span className="sr-only">{totalHoursCompleted === 100 ? "You've reached " : "You haven't reached "}You haven&apos;t reached </span>
                    100 hours
                </p>
                
                {totalHoursCompleted !== 100 ? <i className="far fa-star"></i> : <i className="fas fa-star complete"></i>}
            </div>
        </div>
    )
}


const DownloadWowCertificate = ({matrixUserData}) => {
    const { state } = useContext(WorkExperienceContext);
    const downloadWowCertRef = useRef(null);
    const wowData = state[1];
    const hoursCompleted = state[1].length ? calculateProgress(wowData) : 0
    const milestone = (
          hoursCompleted >= 100 ? 100
        : hoursCompleted >= 50 ? 50 
        : 0
    )

    return (<>
        {milestone > 0 &&
            <div className="wow-cert-dl" ref={downloadWowCertRef}>
                <p className="wow-cert-dl__content">
                    Congratulations on hitting your {milestone} hours in the WOW challenge!
                </p>
                <button className="wow-cert-dl__button" onClick={()=>{
                    generateWowCertificate(
                        matrixUserData, 
                        wowData,
                        milestone,
                        downloadWowCertRef,
                    )
                }}>Download your Certificate of Achievement</button>
            </div>
        }
    </>)
}

export const LandPageProgressBar = ({matrixUserData}) => {
    return (
        <div className="progress-bar__sec-container">
            <h2 className="progress-bar__sec-container-title">Your current progress</h2>
            <ProgressBar />
            <DownloadWowCertificate
                matrixUserData={matrixUserData}
            />
        </div>
    )
}

// PropTypes
SuccessMessage.propTypes = {
    closeForm: PropTypes.func,
    matrixUserData: PropTypes.object
}

PrintAllExperience.propTypes = {
    experiences: PropTypes.array, 
    editAction: PropTypes.func
}

WowChallenge.propTypes = {
    matrixUserData: PropTypes.object
}

LandPageProgressBar.propTypes = {
    matrixUserData: PropTypes.object
}

DownloadWowCertificate.propTypes = {
    matrixUserData: PropTypes.object,
    currentExp: PropTypes.array
}